/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const AccountSettingsPage = lazyLoad(
  () => import('./index'),
  module => module.AccountSettingsPage,
);
